import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../components/notification/NotificationContainer";
import { addCurrency, editCurrency } from "../../features/currenciesSlice";
import { getCountries } from "../../features/countriesSlice";
import { closeModal } from "../../features/modalSLice";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import Loading from "../../components/loading/Loading";
import AddResource from "../../components/header/AddResource";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import loadStatus from "../../util/loadStatus";

const AddCurrency = ({ id, edit }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const countries = useSelector((state) => state.countries.data);
  const currency = useSelector((state) => state.currencies.selected);
  const currencyLoad = useSelector(
    (state) => state.currencies.load.getCurrency
  );
  const addCurrencyLoad = useSelector(
    (state) => state.currencies.load.addCurrency
  );
  const editCurrencyLoad = useSelector(
    (state) => state.currencies.load.editCurrency
  );

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    // resolver: zodResolver(addCurrencySchema),
    defaultValues: { name: "" },
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      if (edit) {
        const res = await dispatch(editCurrency({ id, data: data }));
        if (editCurrency.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Community Updated Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        const res = await dispatch(addCurrency(data));
        if (addCurrency.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Currency Added Successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getCountries());
  }, []);

  useEffect(() => {
    if (currency.id && edit) {
      reset({
        province_id: currency.province_id,
        name: currency.name,
        code: currency.code,
        symbol: currency.symbol,
        country_id: currency.country_id,
      });
    }
  }, [currency, countries]);

  if (currencyLoad === loadStatus.loading && edit) {
    return (
      <div className="min-w-72 sm:min-w-96 lg:min-w-96 w-full h-96">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-w-72 sm:min-w-[26rem] lg:min-w-96">
      <AddResource title={edit ? "Edit Currency" : "Add Currency"} />
      <form
        autoCorrect="off"
        autoComplete="off"
        aut
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col justify-center items-center gap-2 w-full">
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Name"
            name="name"
            errors={errors.name}
          />

          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Symbol"
            name="symbol"
            errors={errors.symbol}
          />

          <InputField
            register={register}
            type="text"
            autoComplete="off"
            label="Code"
            name="code"
            errors={errors.symbol}
          />

          <SelectField
            data={[{ id: "", name: "-- Select Country" }, ...countries]}
            register={register}
            label="Country"
            name="country_id"
            errors={errors.country_id}
          />
        </div>
        {/* <div className="flex items-center justify-end py-6">
          <button className="add-rss-btn" type="submit">
            Submit
          </button>
        </div> */}
        <ResourseButtons loading={addCurrencyLoad || editCurrencyLoad} />
      </form>
    </div>
  );
};

export default AddCurrency;
